import { render, staticRenderFns } from "./DpcDetails.vue?vue&type=template&id=7e3b033c&"
import script from "./DpcDetails.vue?vue&type=script&lang=js&"
export * from "./DpcDetails.vue?vue&type=script&lang=js&"
import style0 from "./DpcDetails.vue?vue&type=style&index=0&id=7e3b033c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports